import { appApiRoutes } from '@riskbase/types/http/appApi';
import type { RouteResponse } from 'types/RequestRoute';

export type CssPropertyAnalysisResponse = RouteResponse<
  typeof appApiRoutes.propertyAnalysis.listCssProperties
>;

export type CssPropertyAnalysisItem =
  CssPropertyAnalysisResponse['data'][number];

export type CssDatasetDecision = 'Pending' | 'Include' | 'Exclude';

export type CssResolvableField =
  | 'heightCategory'
  | 'heightMetres'
  | 'buildingAgeBand'
  | 'populationDensityBand';

export type CssPropertyAnalysisSummary = CssPropertyAnalysisResponse['summary'];

export type CssPropertyAnalysisPagination =
  CssPropertyAnalysisResponse['pagination'];

export type CssPropertyAnalysisFilterOptions = RouteResponse<
  typeof appApiRoutes.propertyAnalysis.getCssFilterOptions
>;

export type CssPropertyAnalysisFilter = {
  search: string;
  priorities: string[];
  datasetDecisions: string[];
  hasConflicts: boolean | undefined;
  heightCategories: string[];
  buildingAgeBands: string[];
  populationDensityBands: string[];
};

export const defaultCssPropertyAnalysisFilter: CssPropertyAnalysisFilter = {
  search: '',
  priorities: [],
  datasetDecisions: [],
  hasConflicts: undefined,
  heightCategories: [],
  buildingAgeBands: [],
  populationDensityBands: [],
};

export type PropertyAnalysisState = {
  items: CssPropertyAnalysisItem[];
  updatedProperty: CssPropertyAnalysisItem | null;
  summary: CssPropertyAnalysisSummary;
  pagination: CssPropertyAnalysisPagination;
  filter: CssPropertyAnalysisFilter;
  filterOptions: CssPropertyAnalysisFilterOptions;
  filterOptionsLoadStatus: null | 'loading' | 'loaded' | 'error';
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  exportLoadStatus: null | 'loading' | 'loaded' | 'error';
  exportError: string | null;
  decisionUpdatePropertyId: string | null;
  decisionUpdateError: string | null;
  decisionUpdateErrorPropertyId: string | null;
  derivedFieldUpdatePropertyId: string | null;
  derivedFieldUpdateField: CssResolvableField | null;
  derivedFieldUpdateError: string | null;
};

export const defaultCssPropertyAnalysisSummary: CssPropertyAnalysisSummary = {
  total: 0,
  pending: 0,
  included: 0,
  excluded: 0,
};

export const defaultCssPropertyAnalysisPagination: CssPropertyAnalysisPagination =
  {
    page: 0,
    limit: 50,
    total: 0,
    totalPages: 0,
  };

export const defaultCssPropertyAnalysisFilterOptions: CssPropertyAnalysisFilterOptions =
  {
    priorities: [],
    datasetDecisions: [],
    heightCategories: [],
    buildingAgeBands: [],
    populationDensityBands: [],
  };
